import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callAPIWithoutAuth } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

export const registerUser = createAsyncThunk(
  'auth/register',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await callAPIWithoutAuth(apiUrls.signup, {}, 'POST', userData);
      if (response?.data?.success || response?.data?.status) {
        localStorage.setItem('tempUser', JSON.stringify({
          email: userData.email,
          ...response.data.data
        }));
        return response.data;
      } else {

        return rejectWithValue(response?.data?.message || "Registration failed");
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || "Registration failed");
    }
  }
);

export const verifyOTP = createAsyncThunk(
  'auth/verifyOTP',
  async ({ email, otp }, { rejectWithValue }) => {
    try {
      const response = await callAPIWithoutAuth(apiUrls.verifyEmail, {}, 'POST', { email, otp });

      if (response?.data?.success || response?.data?.status) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.removeItem('tempUser');
        return response.data;
      } else {
        return rejectWithValue(response?.data?.message || "OTP verification failed");
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || "OTP verification failed");
    }
  }
);

export const resendOTP = createAsyncThunk(
  'auth/resendOTP',
  async (email, { rejectWithValue }) => {
    try {
      const response = await callAPIWithoutAuth(apiUrls.resendOtp, {}, 'POST', { email });

      if (response?.data?.success || response?.data?.status) {
        return response.data;
      } else {
        return rejectWithValue(response?.data?.message || "Failed to resend OTP");
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || "Failed to resend OTP");
    }
  }
);

const signupSlice = createSlice({
  name: 'signup',
  initialState: {
    user: null,
    isAuthenticated: false,
    loading: false,
    error: null,
    otpLoading: false,
    resendLoading: false,
  },
  reducers: {
    clearAuthError: (state) => {
      state.error = null;
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      localStorage.clear();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(verifyOTP.pending, (state) => {
        state.otpLoading = true;
        state.error = null;
      })
      .addCase(verifyOTP.fulfilled, (state, action) => {
        state.otpLoading = false;
        state.isAuthenticated = true;
        state.user = action.payload.user;
      })
      .addCase(verifyOTP.rejected, (state, action) => {
        state.otpLoading = false;
        state.error = action.payload;
      })
      .addCase(resendOTP.pending, (state) => {
        state.resendLoading = true;
        state.error = null;
      })
      .addCase(resendOTP.fulfilled, (state) => {
        state.resendLoading = false;
      })
      .addCase(resendOTP.rejected, (state, action) => {
        state.resendLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearAuthError, logout } = signupSlice.actions;
export default signupSlice.reducer;